import { metaData } from "@cornerstonejs/core";

function getNormal(orientation) {
  const [rowX, rowY, rowZ, colX, colY, colZ] = orientation;

  return [
    rowY * colZ - rowZ * colY,
    rowZ * colX - rowX * colZ,
    rowX * colY - rowY * colX
  ];
}

export function sortImageIdsByPatientPosition(imageIds = []) {
  return [...imageIds].sort((a, b) => {
    const aPlane = metaData.get("imagePlaneModule", a);
    const bPlane = metaData.get("imagePlaneModule", b);

    if (!aPlane || !bPlane) {
      return 0;
    }

    const normal = getNormal(aPlane.imageOrientationPatient);

    const aDistance = aPlane.imagePositionPatient.reduce(
      (sum, value, index) => sum + value * normal[index],
      0
    );

    const bDistance = bPlane.imagePositionPatient.reduce(
      (sum, value, index) => sum + value * normal[index],
      0
    );

    return aDistance - bDistance;
  });
}